/** Medya türüne duyarlı mikro-metin sözlüğü (V5-13). */
import { isAudioItem, type MediaKindSubject } from './mediaKind.ts';

export type MediaContext = 'video' | 'music';

export interface MediaCopy {
  play: string;
  resume: string;
  restart: string;
  watched: string;
  progress: string;
  watchlist: string;
  inWatchlist: string;
  addWatchlist: string;
  removeWatchlist: string;
  next: string;
  empty: string;
  playHint: string;
}

const VIDEO: MediaCopy = {
  play: 'Oynat',
  resume: 'Kaldığın Yerden Devam Et',
  restart: 'Baştan Başlat',
  watched: 'İzlendi',
  progress: 'izlendi',
  watchlist: 'Listem',
  inWatchlist: 'Listemde',
  addWatchlist: 'Listeme Ekle',
  removeWatchlist: 'Listemden çıkar',
  next: 'Sıradaki Bölüm',
  empty: 'İzlenecek içerik yok',
  playHint: 'Oynatmak için dokun',
};

const MUSIC: MediaCopy = {
  play: 'Çal',
  resume: 'Dinlemeye Devam Et',
  restart: 'Baştan Çal',
  watched: 'Dinlendi',
  progress: 'dinlendi',
  watchlist: 'Çalma listem',
  inWatchlist: 'Çalma listemde',
  addWatchlist: 'Çalma listeme ekle',
  removeWatchlist: 'Çalma listemden çıkar',
  next: 'Sıradaki Parça',
  empty: 'Dinlenecek parça yok',
  playHint: 'Çalmak için dokun',
};

export function mediaCopy(context: MediaContext): MediaCopy {
  return context === 'music' ? MUSIC : VIDEO;
}

/** Kütüphane türü biliniyorsa uzantısız müzik parçalarını da doğru sınıflar. */
export function mediaContextFor(item: MediaKindSubject, libraryKind?: string | null): MediaContext {
  return isAudioItem(item, libraryKind === 'music' ? 'music' : 'video') ? 'music' : 'video';
}
